"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseQuery = void 0;
var models_1 = require("../../models");
var rxjs_1 = require("rxjs");
var BaseQuery = /** @class */function () {
  function BaseQuery(config, queryService) {
    this.config = config;
    this.queryService = queryService;
    this.parameters = [];
  }
  /**
   * Adds parameter to query
   * @param name Name of parameter
   * @param value Value of parameter
   */
  BaseQuery.prototype.withParameter = function (name, value) {
    this.parameters.push(new models_1.Parameters.QueryParameter(name, value));
    return this;
  };
  /**
   * Adds parameters to query
   * @param parameters Array of parameters
   */
  BaseQuery.prototype.withParameters = function (parameters) {
    var _a;
    (_a = this.parameters).push.apply(_a, parameters);
    return this;
  };
  /**
   * Gets headers used by this query
   */
  BaseQuery.prototype.getHeaders = function () {
    return this.queryService.getHeaders(this._queryConfig);
  };
  BaseQuery.prototype.withUrl = function (url) {
    this.customUrl = url;
    return this;
  };
  BaseQuery.prototype.getParameters = function () {
    return this.parameters;
  };
  BaseQuery.prototype.toPromise = function () {
    return (0, rxjs_1.firstValueFrom)(this.toObservable());
  };
  BaseQuery.prototype.resolveUrlInternal = function (action) {
    // use custom URL if user specified it
    if (this.customUrl) {
      return this.customUrl;
    }
    // use original url
    return this.queryService.getUrl(action, this._queryConfig, this.getParameters());
  };
  return BaseQuery;
}();
exports.BaseQuery = BaseQuery;